import { Editor } from 'grapesjs';
import { faHeading } from '@fortawesome/pro-solid-svg-icons/faHeading';
import { EditorComponentDefinition } from './types';
import {
  GrapesjsComponent,
  renderLocalizedComponent,
} from '../../helpers/render-localized-component';
import { PARENT_TYPE, translateAttributes } from '../../services/copy-paste/copy-paste-utils';
import { Toolbar } from '../utils';
import { referralCodeComponentDefinition } from './referral/referral-code-grapes-component';
import { updateI18nAttributes } from './i18n';

const CLASSNAME = 'qlfeditor-subtitle';

// if subtitle gets added to other composed widgets, add its cases here
const translations = {
  [referralCodeComponentDefinition.id]: 'editor.referral-code.subtitle',
};

// @deprecated
export const subTitleComponentDefinition: EditorComponentDefinition = {
  id: 'subtitle',
  icon: faHeading,
  getLabel: ({ t }) => t('editor.component.subtitle'),
  component: SubTitleComponent,
  copyPasteHelper: (element, context) => {
    const defaultKey = translations[element[PARENT_TYPE]];

    if (!defaultKey) {
      return translateAttributes(element, context.destinationLocales);
    }

    return translateAttributes(element, context.destinationLocales, {
      property: 'content',
      translationKey: defaultKey,
    });
  },
};

// @deprecated
export function SubTitleComponent(editor: Editor) {
  const i18n = editor.I18n;

  editor.DomComponents.addType(subTitleComponentDefinition.id, {
    isComponent(el: HTMLElement) {
      return el.tagName === 'H2' && el.classList.contains(CLASSNAME);
    },
    extend: 'text',
    model: {
      defaults: {
        tagName: 'h2',
        attributes: {
          class: CLASSNAME,
        },
        content: '',
        name: 'subtitle',
        traits: [],
      },
      initToolbar: Toolbar,
    },
    view: {
      init({ model }: { model: any }) {
        this.listenTo(model, 'rte:disable', () => {
          this.getContent().then((content: string) => {
            updateI18nAttributes.call(this, i18n.getLocale(), { content });
          });
        });
      },
      onRender() {
        renderLocalizedComponent(this as GrapesjsComponent, i18n);
      },
    },
  });
}
